import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import {
  SnackbarApiErrorMessage,
  useDataProvider,
  useLocalization,
  useSnackbar,
} from '@ui-framework/index';
import DialogCloseButton from '@product-framework/components/Dialogs/DialogCloseButton';
import { Box, CircularProgress, Typography } from '@mui/material';

function ApiKeyAtrributes({ record }) {
  const key = record.key.padStart(record.key.length + 10, '*') || '';
  return (
    <Box sx={{ mt: 2 }}>
      <Box display="flex" alignItems="center" gap={1}>
        <Typography sx={{ fontWeight: 'bold' }}>API Key</Typography>
        <Typography>{key}</Typography>
      </Box>
      <Box display="flex" alignItems="center" gap={1}>
        <Typography sx={{ fontWeight: 'bold' }}>Description</Typography>
        <Typography>{record.description}</Typography>
      </Box>
    </Box>
  );
}

export default function RevokeApiKeyModal({
  close,
  serviceProviderId,
  record,
}) {
  const { formatMessage } = useLocalization();
  const [loading, setLoading] = useState(false);
  const snackbar = useSnackbar();

  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const { getApiUrl, post } = useDataProvider(provider);

  const revokeAccess = async () => {
    setLoading(true);
    const url = `${getApiUrl()}/sxcl/v1/service-providers/${serviceProviderId}/api-key/deactivate/${record.id}`;
    const response = await post(url);
    if (response?.ok) {
      snackbar.showMessage(
        formatMessage({
          id: 'MESSAGE_API_KEY_REVOKED_SUCCESS',
          defaultMessage: 'Api Key was revoked successfully',
        }),
      );
    } else {
      snackbar.showMessage({
        type: 'error',
        data: <SnackbarApiErrorMessage errors={response?.errors} />,
      });
    }
    setLoading(false);
    close();
  };

  return (
    <Dialog open onClose={close} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {formatMessage({
          id: 'ADD_REVOKE_API_KEY_HEADER',
          defaultMessage: 'Revoke API Key',
        })}
        <DialogCloseButton disabled={loading} onClose={close} />
      </DialogTitle>

      <DialogContent>
        {loading ? (
          <Box textAlign="center">
            <CircularProgress size="30px" />
            <Typography>Processing</Typography>
          </Box>
        ) : (
          <Box>
            <Typography>Do you want to proceed and revoke the key?</Typography>
            <ApiKeyAtrributes record={record} />
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button
          type="button"
          onClick={() => revokeAccess()}
          disabled={loading}
          variant="contained">
          Revoke
        </Button>
        <Button onClick={close}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}
